module.exports = __webpack_public_path__ + "static/security-badge-810b4cd3a370ea056a37edac14c476e2.png";